function normalizeApp (apps = [], version) {
    return apps.map((app) => {
        const versionById = version[app.machineId];

        return {
            ...app,
            host: versionById?.name || "",
            scanTime: versionById?.scanTime  || "",
            machineId: versionById?.machineId  || ""
        };
    });
}

function filterApp (apps) {
    return apps.reduce((acc, app) => {
        if (!(app.__typename === "AppComponent" && app.applicationInstanceId !== null)) {
            acc.appInstances.push(app);

            if (app.__typename === "AppComponent") {
                acc.appComponents.push({
                    ...app,
                    applicationTemplateId: "AppComponent"
                });
            }
        }

        return acc;
    }, {
        appInstances: [],
        appComponents: []
    });
}

export {
    filterApp,
    normalizeApp
};
